import { useMutation, useQueryClient } from "react-query";
import { notifications } from "@mantine/notifications";

import { createCustomView } from "modules/core/api/custom_views";

import { CUSTOM_VIEWS_QUERY_KEY } from "../../queries/useCustomViewsQuery";

export const useCreateCustomViewMutation = () => {
  const queryCLient = useQueryClient();

  return useMutation({
    mutationFn: createCustomView,

    onSuccess: () => {
      notifications.show({
        message: "Custom view created",
        color: "green",
        variant: "light"
      });
    },

    onError: () => {
      notifications.show({
        message: "Failed to create custom view",
        color: "red",
        variant: "light"
      });
    },

    onSettled: () => {
      queryCLient.invalidateQueries(CUSTOM_VIEWS_QUERY_KEY);
    }
  });
};
